import React, { useRef, useState } from "react";
import { Row, Col, Card, Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useAutenticação } from "../../core/contexts/auth";
import { useToast } from "../../core/contexts/toast";
import { ModeloSopSales } from "../../core/models/sopSales";
import { FiltroSopSales, RepositorioSopSales } from "../../core/repositories/sopSalesRepositorio";
import { atualizaTamanhoTabela } from "../../core/utils/funcoes";
import FiltroPI from "./filtro";
import SopSalesKpiChart from "./SopSalesKpiChart";
import SopSalesRegionPieChart from "./SopSalesRegionPieChart";
import SopSalesRevenueStackedBarChart from "./SopSalesRevenueStackedBarChart";
import { SopSalesSalesForecastChart } from "./SopSalesSalesForecastChart";
import "./index.scss";
import SopSalesTable from "./SopSalesTable";
import { Chart as ChartJS, registerables } from 'chart.js';
ChartJS.register(...registerables);

var contador: number = 0;

export default function SopSales() {

  const { t } = useTranslation();
  const bodyRef = useRef(null);
  const { mostrarToast } = useToast();
  const { usuario } = useAutenticação()
  const [filtro, setFiltro] = useState(new FiltroSopSales());
  const [lista, setLista] = useState<ModeloSopSales[]>([])
  const [activeTab, setActiveTab] = useState<'home' | 'table'>('home');
  const [modalSimulation, setModalSimulation] = useState(false);
  const [listaAtual, setListaAtual] = useState<ModeloSopSales[]>([])
  const [editou, setEditou] = useState(false)


  // React.useEffect(() => {
  //   carregarDados(filtro)
  // }, []);

  React.useEffect(() => {
    setTimeout(() => {
      atualizaTamanhoTabela()
      // Seu código a ser executado quando a altura da página mudar para atualizar o tamanho da tabela
      const observer = new MutationObserver(atualizaTamanhoTabela);
      if (bodyRef.current) {
        observer.observe(bodyRef.current, { attributes: true, childList: true, subtree: true });
      }
      return () => {
        observer.disconnect();
      };
    }, 1000);

  }, []);


  React.useEffect(() => {
    if (usuario && usuario.cod_usuario) {
      carregarDados(filtro, true)
    }
  }, [usuario]);

  function diferentes(filtroP: FiltroSopSales) {
    return filtroP.dth_inicio != filtro.dth_inicio || filtroP.dth_fim != filtro.dth_fim || filtroP.cod_business_unit != filtro.cod_business_unit || filtroP.cod_region != filtro.cod_region || filtroP.cod_product_family != filtro.cod_product_family || filtroP.cod_product != filtro.cod_product || filtroP.value != filtro.value
  }
  async function carregarDados(filtroP: FiltroSopSales, forca = false) {
    try {
      if (forca || diferentes(filtroP)) {
        const _contador = contador++;
        if (_contador === contador - 1) {
          filtroP.cod_usuario = usuario?.cod_usuario
          const resposta = await new RepositorioSopSales().getFilter(filtroP)
          console.log(resposta)
          setLista(resposta)
          // cria uma copia do filtro com o mes inicial e final atual
          const filtroCopia = { ...filtroP };
          filtroCopia.dth_inicio = new Date()
          filtroCopia.dth_fim = new Date()
          filtroCopia.dth_inicio.setMonth(filtroCopia.dth_inicio.getMonth() - 1)
          filtroCopia.dth_fim.setMonth(filtroCopia.dth_fim.getMonth() + 1)
          filtroCopia.dth_inicio.setDate(1)
          filtroCopia.dth_fim.setDate(1)
          filtroCopia.dth_inicio.setHours(0, 0, 0, 0)
          filtroCopia.dth_fim.setHours(0, 0, 0, 0)
          const resposta2 = await new RepositorioSopSales().getFilter(filtroCopia)
          setListaAtual(resposta2)
          // await carregarLista(filtro);
          // atualizarInterface();
        }
      }
    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }

  function atualizarFiltro(filtroP: FiltroSopSales) {
    if (diferentes(filtroP)) {
      carregarDados(filtroP);
      setFiltro({ ...filtroP });
    }
  }

  async function filtrarDados(novoFiltro: FiltroSopSales) {
    novoFiltro.flg_aberto = false
    atualizarFiltro(novoFiltro)
    // carregarDados(novoFiltro);
  }

  async function fecharModalTabela() {
    setModalSimulation(false)
    if (editou) {
      setFiltro({ ...filtro });
    }
  }

  function atualizarInterface() {
    setFiltro({ ...filtro });
    carregarDados(filtro,true);
  }

  return (
    <div className="SopSales " ref={bodyRef}>
      <div className="px-2">

        <FiltroPI
          titulo={t("Sales")}
          filtro={{ ...filtro }}
          atualizarFiltro={atualizarFiltro}
          permissaoEditar={true}
          filtrarDados={filtrarDados}
          onSimulation={() => { setModalSimulation(true); setEditou(false) }}
        />
      </div>


      <div className="table-100" >
        <div id="tabela">
          <div className="table-responsive">

            <div className="tabs-container card px-2  shadow-sm border-0">
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <button className={`nav-link ${activeTab === 'home' ? 'active' : ''}`} onClick={() => setActiveTab('home')}                  >
                    Home
                  </button>
                </li>
                <li className="nav-item">
                  <button className={`nav-link ${activeTab === 'table' ? 'active' : ''}`} onClick={() => setActiveTab('table')}                  >
                    Table
                  </button>
                </li>
              </ul>

              <div className="tab-content py-2 ">
                <div className="tab-pane" style={{ display: activeTab === 'home' ? 'block' : 'none' }}  >

                  {/* <div className={`tab-pane ${activeTab === 'home' ? 'active' : 'd-none'}`}> */}
                  <Row className="">
                    <Col md={6}>
                      <Card>
                        <SopSalesSalesForecastChart filtro={filtro} home={false} onChange={atualizarInterface}   />
                      </Card>
                    </Col>

                    <Col md={6}>
                      <Card>
                        <SopSalesKpiChart filtro={filtro} activeTab={activeTab} />
                      </Card>
                    </Col>

                    {/* <Col md={4}>
                        <Card>
                          <GrowthChart />
                        </Card>
                      </Col> */}
                  </Row>

                  <Row className=" mt-3">
                    <Col md={9}>
                      <Card>
                        <SopSalesRevenueStackedBarChart filtro={filtro} />
                      </Card>
                    </Col>

                    <Col md={3}>
                      <Card>
                        <SopSalesRegionPieChart filtro={filtro} />
                      </Card>
                    </Col>

                    {/* <Col md={12}>
                        <Card>
                          <SalesForecastChart3 />
                        </Card>
                      </Col> */}
                  </Row>
                </div>

                {/* <div className={`tab-pane ${activeTab !== 'home' ? 'active' : 'd-none'}`}> */}
                <div className="tab-pane" style={{ display: activeTab !== 'home' ? 'block' : 'none' }}  >
                  {/* <Row className=" mt-3">
                      <Col md={12}>
                        <Card >
                          <SummaryTable />
                        </Card>
                      </Col>
                    </Row> */}

                  <div className="table-100" >
                    <strong className=" title-card pb-1">Sales vs Forecast vs Budget Table</strong>
                    <div className="py-2">
                      <SopSalesTable lista={lista} setLista={setLista} activeTab={activeTab} filtro={filtro} salvarValor={atualizarInterface} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      {/* Criar modal com a tabela */}
      <Modal show={modalSimulation} onHide={fecharModalTabela} size="xl" centered>
        <Modal.Header closeButton onHide={fecharModalTabela}>
          <Modal.Title>Simulation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SopSalesTable salvarValor={atualizarInterface} lista={listaAtual} setLista={(lista) => { setListaAtual(lista), setEditou(true) }} simulation={true} activeTab={activeTab} filtro={filtro} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={fecharModalTabela}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>


    </div>
  );
}
